import './style.scss';

function Overlay({ outsideClick }: { outsideClick: () => void}) {
  return <div onClick={outsideClick} className="overlay" />;
}

export default Overlay;
